import { calculateIndicesPips } from './indicesPips';

interface IPipsCalculating {
  ask: string;
  bid: string;
  pipSize: number;
  stopsLevel: number;
  fixDigit: number;
  side: 'Buy' | 'Sell';
}

type TPipsCalculating = (params: IPipsCalculating) => string;

export const calculateProfitPips: TPipsCalculating = ({
  ask,
  pipSize,
  stopsLevel,
  bid,
  fixDigit,
  side,
}) => {
  const amplitude = pipSize * +calculateIndicesPips(stopsLevel, 'toRate');

  return side === 'Buy'
    ? (Number(bid) + amplitude).toFixed(fixDigit)
    : (Number(ask) - amplitude).toFixed(fixDigit);
};

export const calculateStopLossPips: TPipsCalculating = ({
  ask,
  pipSize,
  stopsLevel,
  bid,
  fixDigit,
  side,
}) => {
  const amplitude = pipSize * +calculateIndicesPips(stopsLevel, 'toRate');

  return side === 'Buy'
    ? (Number(bid) - amplitude).toFixed(fixDigit)
    : (Number(ask) + amplitude).toFixed(fixDigit);
};
